import get from 'lodash/get';
import adsConfig from '../../../config/ads';
import { buildPostAdModel } from '../../../utils/ad_util';

export default function(state = {}, action) {
  const { store } = action;
  const typeMap = {
    BRANDS_THAT_MATTER_PAGE_LOADING() {
      return {
        isLoading: true,
        brandsThatMatterPage: action.brandsThatMatterPage
      };
    },
    BRANDS_THAT_MATTER_PAGE_LOADED() {
      const currentState = store.getState();
      const site = get(currentState, 'config.site') || 'fastcompany';
      const adModelData = buildPostAdModel(
        adsConfig,
        site,
        'brands-that-matter',
        'franchisePage'
      );

      // Override this for MCP
      // adModelData.model.adzone = 'leadership/best-workplaces-for-innovators';
      return {
        isLoading: false,
        data: action.brandsThatMatterPage,
        ads: adModelData
      };
    },
    BRANDS_THAT_MATTER_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.brandsThatMatterPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
